// extracted by mini-css-extract-plugin
export default {"page-sub-header":"styles_page-sub-header__Ter31"};